import { compose, getContext, pure } from 'recompose';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';

import Filters from './filters';

const enhance = compose(
  withTranslation(['tasks', 'common']),
  pure,
  getContext({
    onSelectAssignee: PropTypes.func,
    onSelectAssigner: PropTypes.func,
    onSelectSprintsStatus: PropTypes.func,
  }),
);
export default enhance(Filters);
